module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1014.407bfb5c.jpg";